import { render, staticRenderFns } from "./batchPriceAdjustment.vue?vue&type=template&id=54f576b0&scoped=true"
import script from "./batchPriceAdjustment.vue?vue&type=script&lang=js"
export * from "./batchPriceAdjustment.vue?vue&type=script&lang=js"
import style0 from "./batchPriceAdjustment.vue?vue&type=style&index=0&id=54f576b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f576b0",
  null
  
)

export default component.exports